import { defineMessages } from 'react-intl'

export const clipHeaderMessages = defineMessages({
  download: {
    id: 'clipHeader.download',
    description: 'Text on button to download clip',
    defaultMessage: 'Download',
  },
})
